import { React, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Button from "../../../../../../components/PrimaryButton.js";
import TextField from "@material-ui/core/TextField";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import Checkbox from "@material-ui/core/Checkbox";
import { Link } from "react-router-dom";
import ParametersContainer from "./ParametersContainer";
import {
  kNeighborArr,
  logisticRegressionArr,
  decisionTreeArr,
  randomForestArr,
  extraTreesArr,
  adaBoostArr,
  supportVectorArr,
} from "./ClassicParameterData";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    height: "100%",
  },
  mainContainer: {
    height: "100%",
    margin: "0 5%",
  },
  paper: {
    height: "59vh",
  },
  rightPaper1: {
    height: "33vh",
    position: "relative",
  },
  rightPaper2: {
    marginTop: "3vh",

    height: "23vh",
  },
  header: {
    borderBottom: "1px solid #FF7E67",
    position: "relative",
    top: 10,
  },
  button: {
    width: 80,
    height: 30,
    position: "absolute",
    right: 10,
    bottom: 10,
  },
  searchBar: {
    margin: "20px 10px",
    width: "90%",
  },
  nextButton: {
    position: "absolute",
    bottom: "1%",
    right: "5%",
  },
  closeIcon: {
    cursor: "pointer",
    position: "absolute",
    right: "15%",
    color: "#FF7E67",
  },
  chosenModelsContainer: {
    height: "70%",
    overflow: "scroll",
    position: "relative",
    top: 10,
  },
}));

const Classic = (props) => {
  const classes = useStyles();
  const [checked, setChecked] = useState([]);
  const [isAddButtonClicked, setIsAddButtonClicked] = useState(false);
  const [selectedChosenModels, setSelectedChosenModels] = useState([]);
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);
  const classicModels = [
    "K-Neighbor Classifier",
    "Logistic Regression",
    "Decision Tree Classifier",
    "Random Forest Classifier",
    "Extra Trees Classifier",
    "Ada Boost Classifier",
    "Support Vector Classification",
  ];
  const [models, setModels] = useState(classicModels);

  const handleToggle = (value) => () => {
    const currentIndex = checked.indexOf(value);
    const newChecked = [];
    if (currentIndex === -1) {
      newChecked.push(value);
      setIsButtonDisabled(false);
    } else {
      newChecked.splice(currentIndex, 1);
      setIsButtonDisabled(true);
    }
    setChecked(newChecked);
  };

  const modelCheckList = models.map((value, index) => {
    return (
      <ListItem
        style={{ height: "10%" }}
        key={index}
        role={undefined}
        dense
        button
        onClick={handleToggle(value)}
      >
        <ListItemIcon>
          <Checkbox
            edge="start"
            checked={checked.indexOf(value) !== -1}
            tabIndex={-1}
            disableRipple
            inputProps={{ "aria-labelledby": value }}
            key={value}
          />
        </ListItemIcon>
        <ListItemText id={value} primary={`${value}`} />
      </ListItem>
    );
  });

  const handleRemoveModelFromModels = (item) => {
    const array = [...models];
    const index = array.indexOf(item);
    if (index !== -1) {
      array.splice(index, 1);
      setModels(array);
    }
  };

  const handleAddClick = () => {
    setIsAddButtonClicked(true);
    setSelectedChosenModels([...selectedChosenModels, checked]);
    handleRemoveModelFromModels(checked[0]);
    setChecked([]);
    setIsButtonDisabled(true);
  };

  const addToClassicModels = (modelName) => {
    const array = [...models, modelName[0]];
    setModels(array);
  };

  const handleRemoveFromChosenModels = (modelName) => {
    const array = [...selectedChosenModels];
    const index = array.indexOf(modelName);
    if (index !== -1) {
      array.splice(index, 1);
      setSelectedChosenModels(array);
    }
    addToClassicModels(modelName);
  };

  const handleNextButton = () => {
    props.onSelect();
    sessionStorage.setItem("models", JSON.stringify(selectedChosenModels));
  };

  return (
    <div className={classes.mainContainer}>
      <Grid className={classes.root} container justify="center" spacing={10}>
        <Grid item xs={6}>
          <Paper className={classes.paper} elevation={0}>
            <div className={classes.header}>
              <h3>Classic Models</h3>
            </div>
            <TextField
              id="outlined-basic-classic"
              label="Search classic models.."
              variant="outlined"
              className={classes.searchBar}
            />
            {modelCheckList}
          </Paper>
        </Grid>
        <Grid item xs={6}>
          <Paper className={classes.rightPaper1} elevation={0}>
            <div className={classes.header}>
              <h3>Parameters</h3>
            </div>
            {checked[0] === "K-Neighbor Classifier" && (
              <ParametersContainer data={kNeighborArr} />
            )}
            {checked[0] === "Logistic Regression" && (
              <ParametersContainer data={logisticRegressionArr} />
            )}
            {checked[0] === "Decision Tree Classifier" && (
              <ParametersContainer data={decisionTreeArr} />
            )}
            {checked[0] === "Random Forest Classifier" && (
              <ParametersContainer data={randomForestArr} />
            )}
            {checked[0] === "Extra Trees Classifier" && (
              <ParametersContainer data={extraTreesArr} />
            )}
            {checked[0] === "Ada Boost Classifier" && (
              <ParametersContainer data={adaBoostArr} />
            )}
            {checked[0] === "Support Vector Classification" && (
              <ParametersContainer data={supportVectorArr} />
            )}

            <Button
              styleClasses={classes.button}
              onClick={handleAddClick}
              innerText="Add"
              isDisabled={isButtonDisabled}
            ></Button>
          </Paper>
          <Paper className={classes.rightPaper2} elevation={0}>
            <div className={classes.header}>
              <h3>Chosen Models</h3>
            </div>
            <div className={classes.chosenModelsContainer}>
              {isAddButtonClicked &&
                selectedChosenModels.map((model, index) => (
                  <ul key={index}>
                    <li style={{ position: "relative" }}>
                      {model}
                      <FontAwesomeIcon
                        className={classes.closeIcon}
                        icon={faTimes}
                        onClick={() => handleRemoveFromChosenModels(model)}
                      />
                    </li>
                  </ul>
                ))}
            </div>
          </Paper>
        </Grid>
      </Grid>
      <Link to="/methods/new-method/training">
        <Button
          styleClasses={classes.nextButton}
          onClick={handleNextButton}
          innerText="Next"
        ></Button>
      </Link>
    </div>
  );
};

export default Classic;
